import React from 'react'
import { Link } from 'gatsby'
import { Box, Image, Heading, Text } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'

const ExploreCard = ({ src, type, to }) => {
  const { t } = useTranslation('comoon')

  return (
    <Box
      maxWidth="360px"
      width={1}
      height="380px"
      mt={['-1020px', '-1020px', '-170px']}
      bg="white"
      sx={{
        boxShadow: '0px 30px 80px rgba(33, 47, 64, 0.1)',
        borderRadius: '10px'
      }}
    >
      <Link
        to={to}
        css={{
          display: 'block',
          padding: '24px 32px 32px'
        }}
      >
        <Image src={src} height="144px" mb={6} />

        <Heading
          as="h3"
          variant="level3"
          fontSize="24px"
          lineHeight="130%"
          textAlign="center"
          mb={4}
        >
          {t(`explore.cards.${type}.title`)}
        </Heading>

        <Text as="p" variant="level6" textAlign="center">
          {t(`explore.cards.${type}.description`)}
        </Text>
      </Link>
    </Box>
  )
}

ExploreCard.propTypes = {
  type: PropTypes.string,
  src: PropTypes.string,
  to: PropTypes.string
}

export default ExploreCard
